import { COOKIEYES_DISABLED_LANDINGS } from '../constants';
import { parseOnboardingPath } from '../../locales/languageConfig';

const COOKIEYES_RETURN_STATE_KEY = 'cookieyes_disabled_return_state';
// Same lifetime as the payment tab snapshots (Cash App's authorization expires after 60 min)
const COOKIEYES_RETURN_STATE_TTL_MS = 60 * 60 * 1000;

type CookieYesReturnState = {
  landing: string;
  flow: string[];
  savedAt: number;
};

export const isCookieYesDisabled = (
  pathname: string,
  landing: string,
  flow: string[] | null,
): boolean => {
  const page = parseOnboardingPath(pathname).cleanPath.replace(/\//g, '');
  if (COOKIEYES_DISABLED_LANDINGS.includes(page)) return true;

  // After a reload mid-flow the URL is a flow screen, so the landing comes from the persisted store
  return COOKIEYES_DISABLED_LANDINGS.includes(landing) && Boolean(flow?.includes(page));
};

// localStorage throws in private mode or when site data is blocked; CookieYes then just shows as before
export const saveCookieYesReturnState = (landing: string, flow: string[]): void => {
  try {
    const state: CookieYesReturnState = { landing, flow, savedAt: Date.now() };
    localStorage.setItem(COOKIEYES_RETURN_STATE_KEY, JSON.stringify(state));
  } catch {
    // Storage unavailable
  }
};

export const clearCookieYesReturnState = (): void => {
  try {
    localStorage.removeItem(COOKIEYES_RETURN_STATE_KEY);
  } catch {
    // Storage unavailable
  }
};

export const readCookieYesReturnState = (): CookieYesReturnState | null => {
  try {
    const value = localStorage.getItem(COOKIEYES_RETURN_STATE_KEY);
    const state = value ? (JSON.parse(value) as CookieYesReturnState) : null;

    return state && Date.now() - state.savedAt <= COOKIEYES_RETURN_STATE_TTL_MS ? state : null;
  } catch {
    return null;
  }
};
